/// <reference types="vite/client" />
import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';

const target = document.getElementById('app');
if (!target) {
  throw new Error('div#app not found');
}

// Os esboços só existem no servidor de desenvolvimento: o build de produção corta este ramo.
const isSketchPage = import.meta.env.DEV && window.location.pathname.startsWith('/esbocos');
const app = isSketchPage
  ? mount((await import('./sketches/Sketches.svelte')).default, { target })
  : mount(App, { target });

export default app;
